import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

import FooterForm from "components/forms/FooterForm";
import LogoImage from "images/impots-reduc-logo.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";

const Container = tw.footer`relative bg-gray-200 text-gray-700 -mb-8 px-8 py-20 lg:py-12 w-full z-10`;
const Content = tw.div` mx-auto relative z-10`;
const SixColumns = tw.div`flex flex-wrap text-left max-sm:text-left justify-between -mt-12 max-sm:justify-center`;

const Column = tw.div`px-4 max-sm:px-0 mt-12 w-1/4 max-sm:min-w-[300px]`;

const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.span`mt-3 block`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-700 pb-1 transition duration-300`;

const SubscribeNewsletterColumn = tw(Column)`text-center lg:text-left w-full! lg:w-auto! mt-20 lg:mt-12`;
const SubscribeNewsletterContainer = tw.div`max-w-sm mx-auto lg:mx-0 `;
const SubscribeText = tw.p`mt-2 lg:mt-6 text-sm font-medium text-gray-600`;
const SubscribeForm = tw.form`mt-4 lg:mt-6 text-sm sm:flex max-w-xs sm:max-w-none mx-auto sm:mx-0`;
const Input = tw.input`bg-gray-300 px-6 py-3 rounded sm:rounded-r-none border-2 sm:border-r-0 border-gray-400 hover:border-primary-500 focus:outline-none transition duration-300 w-full`;
const SubscribeButton = tw(PrimaryButtonBase)`mt-4 sm:mt-0 w-full sm:w-auto rounded px-8 py-3`;

const Divider = tw.div`my-10 border-b-2 border-gray-300 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-[10vw] h-[4vw] min-w-[75px] min-h-[35px] max-lg:w-[17vw] max-lg:h-[8vw] max-sm:w-[40vw] max-sm:h-[12vw]`
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-800`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-500`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default () => {
  return (
    <Container>
      <Content>
        <SixColumns>
          <Column>
            <ColumnHeading>Qui sommes-nous ?</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <p tw="">Impots-reduc.fr est une plateforme de mise en relation gratuite entre Contribuables et Experts en Fiscalité. Tout conseil fiscal et patrimonial est fourni par nos partenaires, signataires de notre charte qualité et tous membres d’une chambre de gestion de patrimoine.</p>
              </LinkListItem>
             
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Lire aussi</ColumnHeading>
              <ul tw="mt-6 text-sm font-medium">
                <li tw="mt-3 hover:underline">
                <a href="/conseil-fiscal" tw="block">Conseil fiscal pour particuliers et professionnels</a>
                </li>
                <li tw="mt-3 hover:underline">
                <a href="/revenus-complementaires-defiscalises" tw="block">Percevez des revenus complémentaires défiscalisés</a>
                </li>
              </ul>
          </Column>
          <Column>
            <ColumnHeading>Coordonnées</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <span tw="block">Impots-Reduc.fr</span>
                <span tw="block font-bold">Siège social: </span>
                <span tw="block">23 rue Crépet</span>
                <span tw="block">69007 Lyon</span>
                <span tw="block"><span tw="font-bold">Mail:</span> contact@impots-reduc.fr</span>
                <a href="tel:+33485696407" tw="block"><span tw="font-bold">Tel:</span>  04.85.69.64.07</a>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
          <ColumnHeading>Contact</ColumnHeading>
            <FooterForm 
              formAction="https://formsubmit.co/contact@impots-reduc.fr" 
              method="POST"
            >
              <input type="hidden" name="_template" value="box"></input>
              <input type="hidden" name="_captcha" value="false"></input>
              <input type="hidden" name="_subject" value="Contact message"></input>
            </FooterForm>
          </Column>
          {/* <SubscribeNewsletterColumn>
            <SubscribeNewsletterContainer>
              {/* <ColumnHeading>Subscribe to our Newsletter</ColumnHeading> 
                
            </SubscribeNewsletterContainer>
          </SubscribeNewsletterColumn> */}
        </SixColumns>
        
        <Divider />
        <ThreeColRow>
          <LogoContainer>
            <LogoImg src={LogoImage} alt="logo impôts-reduc" />
          </LogoContainer>
          <CopywrightNotice>&copy; IMPÔTS RÉDUC. Tous droits réservés - <Link href="/mentions-legales">Mentions Légales</Link></CopywrightNotice>
          
        </ThreeColRow>
      </Content>
    </Container>
  );
};
